<ion-icon name="close-outline" class="text-4xl close-icon cursor-pointer"></ion-icon>

<div class="flex flex-col justify-center p-5">
  <div class="title text-2xl">{{title | transloco}}</div>
  <div class="mt-2">{{text}}</div>
</div>
